import {EntryWithState} from '../entry/EntryWithStates';
import {Pageable} from '../common/pageable';

export interface CensusData {
  censusYear: number;
  censusActive: boolean;
  censusPeriod: CensusPeriod;
  ageGroups: CensusAgeGroup[];
  beneficiaries: CensusBeneficiary[];
  organizationId: number;
  shadowCensusData: ShadowCensusData;
  savingShadowCensus: boolean;
}

export interface ShadowCensusData {
  id?: number;
  male: number;
  maleDelta?: number;
  female: number;
  femaleDelta?: number;
  other: number;
  otherDelta?: number;
  total: number;
  totalDelta?: number;
}


export interface CensusPeriodData {
  year: number;
  censusTotal: number;
  editable: boolean;
}

export interface CensusAgeGroup {
  id: string;
  male: number;
  female: number;
  other: number;
  total: number;
  ageGroupData: AgeGroupsData;
}

export interface CensusPeriod {
  id: number;
  year: number;
  startDate: Date;
  endDate: Date;
  historical: boolean;
}

export interface CensusBeneficiary {
  id: number;
  male: number;
  female: number;
  other: number;
  total: number;
  beneficiaryCategoryData: BeneficiaryData;
}

export interface AgeGroupsData extends EntryWithState {
  id?: number;
  ageGroupName: string;
  defaultAgeGroup: AgeGroupsData;
  endingAge: number;
  global: boolean;
  groupType: string;
  startingAge: number;
  active: boolean;
}

export interface CensusesDataGetResponse extends Pageable {
  content: CensusesData[];
}

export interface CensusesData extends EntryWithState {
  id?: number;
  year: number;
  startDate: Date;
  endDate: Date;
  historical: boolean;
}

export interface BeneficiaryDataGetResponse extends Pageable {
  content: BeneficiaryData[];
}

export interface BeneficiaryData extends EntryWithState {
  id?: number;
  beneficiaryCategoryType: string;
  beneficiaryCategoryCategory: string;
  beneficiaryCategoryDescription: string;
  beneficiaryCategoryGuidance: string;
  active: boolean;
}

export interface GraphData {
  total: number;
  delta: number;
  censusUpdatedLastYear: boolean;
  barGraphData: BarGraph;
  donutBarData: DonutGraph;
  lineGraphData: BarGraph;
  shadowData?: ShadowCensusData;
  beneficiaries?: CensusBeneficiary[];
  beneficiariesGraph?: DonutGraph;
}
export interface GraphRequestOptions {
  id: number;
  type: string;
  barDate: string;
  lineDate: string;
  route?: string;
}

export interface BarGraph {
  years: number[];
  labels?: string[];
  dataList: any[];
  datasets?: any[];
  totals: number[];
  deltas: number[];
  totalsDeltas?: any[];
}

export interface DonutGraph {
  labels: string[];
  values: Object;
  datasets?: any[];
}

export const GraphTypes = [
  {label: 'Total by gender', value: 'TOTAL_BY_GENDER'},
  {label: 'Adults vs Youth', value: 'ADULT_VS_YOUTH'},
  {label: 'Youth by gender', value: 'YOUTH_BY_GENDER'},
  {label: 'Total by age groups', value: 'TOTAL_BY_AGE_GROUPS'},
  {label: 'Adults by gender', value: 'ADULTS_BY_GENDER'}
];

export const GraphDates = [
  {label: 'Current ', value: 'CURRENT'},
  {label: 'Last 3 years', value: 'THREE_YEARS'},
  {label: 'Last 3 triennia', value: 'THREE_TRIENIAS'},
  {label: 'Three 5 years', value: 'THREE_FIVE_YEARS'},
  {label: 'Three 10 years', value: 'THREE_TEN_YEARS'},
  {label: 'Three 20 years', value: 'THREE_TWENTY_YEARS'}
];
